import TimeDuration from './timeFormats';
import Dictionary from './dictionary';

const listOfAirlines = (operatingAirlines) => {
  return `${operatingAirlines
    .map((airline, airlineIndex) => {
      return `${airline.name}${airlineIndex !== operatingAirlines.length - 1 ? ', ' : ''}`;
    })
    .join('')}`;
};

const numberOfStops = (segments, renderContent) => {
  switch (true) {
    case segments.length === 2:
      return `${segments.length - 1} ${renderContent(
        Dictionary.airStopsNumberSingleLabel.key,
        Dictionary.airStopsNumberSingleLabel.defaultValue,
      )}`;
    case segments.length > 2:
      return `${segments.length - 1} ${renderContent(
        Dictionary.airStopsNumberLabel.key,
        Dictionary.airStopsNumberLabel.defaultValue,
      )}`;
    default:
      return renderContent(Dictionary.airNonstopLabel.key, Dictionary.airNonstopLabel.defaultValue);
  }
};

const countStopsLabel = (segments, label) => {
  if (segments.length > 1) {
    return ` ${label || 'in '} 
      ${segments
        .map((segment, segmentIndex) => {
          return segmentIndex < segments.length - 1
            ? `${segment.arrival.airport.code}${segmentIndex !== segments.length - 2 ? ', ' : ''}`
            : ``;
        })
        .join('')}`;
  }
  return '';
};

const countStopsLabelBig = (flightInfo) => {
  switch (true) {
    case flightInfo.flightSegments.length === 2:
      return `${TimeDuration(flightInfo.flightSegments[0].layoverMins)} ${
        flightInfo.flightSegments[0].arrival.airport.code
      }`;
    case flightInfo.flightSegments.length > 2:
      return `${flightInfo.flightSegments
        .map((segment, segmentIndex) => {
          return segmentIndex < flightInfo.flightSegments.length - 1
            ? `${segment.arrival.airport.code}${
                segmentIndex !== flightInfo.flightSegments.length - 2 ? ', ' : ''
              }`
            : ``;
        })
        .join('')}`;
    default:
      return ``;
  }
};

export default { listOfAirlines, numberOfStops, countStopsLabel, countStopsLabelBig };
